export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14849.a47e8511.jpg";